import { Link } from "gatsby";
import ReactMarkdown from 'react-markdown';
import React from "react";
import remarkGfm from 'remark-gfm';
import Layout from '../../../components/layout';
import MainContent from '../../../components/maincontent';
import Seo from "../../../components/seo";
import thursday from "../../../components/schedule/2026/thursday.md"
import friday from "../../../components/schedule/2026/friday.md"
import saturday from "../../../components/schedule/2026/saturday.md"
import sunday from "../../../components/schedule/2026/sunday.md"
const IndexPage = () => {

  console.log({ thursday, friday, saturday, sunday });

  return (
    <Layout>
      <Seo
        title={`Camp 2026 - Schedule`}
        description={`Schedule for Charity Grace Bible Camp 2026`}
        lang="en"
        meta={[
          {
            content: "God, Jesus, Gospel, Heaven, Salvation, Saved, Grace, Free, How, Mid-Acts, Romans, Charity Grace Bible Church, Illinois",
            name: "keywords"
          }
        ]}
      />

      <MainContent hasArticle={false} hasBanner={false}>
        <div className="grid align--center">
          <div className="grid--3 scheduleButtons align--right print_hidden">
            <Link className="button button--grey" to="/">
              <i className="fa fa-caret-left" aria-hidden="true" /> Back
            </Link>
            </div>

            <div className="grid--7 scheduleButtons align--right print_hidden">
            <a className="Download" href="/assets/Schedules/CharityGraceBibleChurchCampSchedule2026.pdf" download>
              <button>Download Schedule</button>
            </a>
            </div>
                  

          
          <div className="align--center">
            <h2 className="scheduleHeader">Charity Grace Bible Camp Schedule 2026</h2>
            <p>October 8th - October 11th</p>
          </div>

          <div className="table-wrapper">
            <table className="md-table">

              <tbody className="md-tb">
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  components={{
                    table: ({ node, ...props }) => <tbody {...props} />,
                    thead: ({ node, ...props }) => <>{props.children}</>,
                    tbody: ({ node, ...props }) => <>{props.children}</>,
                    tr: ({ node, ...props }) => <tr className="md-tr" {...props} />,
                    th: ({ node, ...props }) => <th className="md-th" {...props} />,
                    td: ({ node, ...props }) => <td className="md-td thursday" {...props} />,
                  }}
                >
                  {thursday}
                </ReactMarkdown>

                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  components={{
                    table: ({ node, ...props }) => <tbody {...props} />,
                    thead: ({ node, ...props }) => <>{props.children}</>,
                    tbody: ({ node, ...props }) => <>{props.children}</>,
                    tr: ({ node, ...props }) => <tr className="md-tr" {...props} />,
                    th: ({ node, ...props }) => <th className="md-th" {...props} />,
                    td: ({ node, ...props }) => <td className="md-td friday" {...props} />,
                  }}
                >
                  {friday}
                </ReactMarkdown>

                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  components={{
                    table: ({ node, ...props }) => <tbody {...props} />,
                    thead: ({ node, ...props }) => <>{props.children}</>,
                    tbody: ({ node, ...props }) => <>{props.children}</>,
                    tr: ({ node, ...props }) => <tr className="md-tr" {...props} />,
                    th: ({ node, ...props }) => <th className="md-th" {...props} />,
                    td: ({ node, ...props }) => <td className="md-td saturday" {...props} />,
                  }}
                >
                  {saturday}
                </ReactMarkdown>

                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  components={{
                    table: ({ node, ...props }) => <tbody {...props} />,
                    thead: ({ node, ...props }) => <>{props.children}</>,
                    tbody: ({ node, ...props }) => <>{props.children}</>,
                    tr: ({ node, ...props }) => <tr className="md-tr" {...props} />,
                    th: ({ node, ...props }) => <th className="md-th" {...props} />,
                    td: ({ node, ...props }) => <td className="md-td sunday" {...props} />,
                  }}
                >
                  {sunday}
                </ReactMarkdown>
              </tbody>
            </table>
          </div>


          <div className="grid--12 qrCodeDiv">
            <img className="qrCode" alt="QR failed to load" src="/assets/images/campScheduleQR.png" />
            <p>Scan for the schedule on your phone.</p>
          </div>
        </div>
      </MainContent>
    </Layout>
  );
};


export default IndexPage;
